module.exports = __webpack_public_path__ + "static/trello-a12e58edce97692f50b36779d63c286d.png";